////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.1                                                            //
//  Summary: Inline error state — the useApi()/useSession() failure path     //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

export interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
}

export function ErrorState ({ message, onRetry }: ErrorStateProps) {
  return (
    <div role="alert" className="rounded border border-line bg-paper p-4 text-ink">
      <p>{message}</p>
      {onRetry && (
        <button type="button" onClick={onRetry} className="mt-2 underline">
          Try again
        </button>
      )}
    </div>
  );
}
